import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useReactions } from '../stores/reactions.js';

const TTL_MS = 2500;

/**
 * Floating bubble next to a PlayerBadge that shows the latest reaction emoji
 * for `userId` for 2.5 seconds before fading. Multiple rapid reactions stack
 * vertically — newest on top.
 */
export function ReactionBubble({ userId }: { userId: string }) {
  const active = useReactions((s) => s.active);
  const prune = useReactions((s) => s.prune);

  useEffect(() => {
    const t = setInterval(() => prune(TTL_MS), 500);
    return () => clearInterval(t);
  }, [prune]);

  const mine = active.filter((p) => p.fromUserId === userId);

  return (
    <div className="pointer-events-none absolute -top-2 left-full ml-1 flex flex-col items-start gap-0.5">
      <AnimatePresence>
        {mine.map((p) => (
          <motion.span
            key={p.id}
            initial={{ opacity: 0, y: 6, scale: 0.7 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -16, scale: 0.6 }}
            transition={{ type: 'spring', stiffness: 260, damping: 18 }}
            className="rounded-full px-2 py-0.5 text-xl"
            style={{
              background: 'color-mix(in oklab, var(--color-felt-deep) 90%, white 6%)',
              border: '1px solid color-mix(in oklab, var(--color-gold) 35%, transparent)',
              lineHeight: 1,
            }}
          >
            {p.emoji}
          </motion.span>
        ))}
      </AnimatePresence>
    </div>
  );
}
